import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maskSettings", "onValueChange", "inputProps", "inputRef", "className", "disabled", "type"];
import React, { useState } from 'react';
import { PatternFormat } from 'react-number-format';
import { CoreInput } from "./CoreInput";
var MaskedInput = function MaskedInput(_ref) {
  var maskSettings = _ref.maskSettings,
    onValueChange = _ref.onValueChange,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    className = _ref.className,
    disabled = _ref.disabled,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    allowEmptyFormatting = _useState2[0],
    setAllowEmptyFormatting = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    number = _useState4[0],
    setNumber = _useState4[1];
  var handleFocus = function handleFocus(e) {
    var _inputProps$onFocus;
    setAllowEmptyFormatting(true);
    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onFocus = inputProps.onFocus) === null || _inputProps$onFocus === void 0 ? void 0 : _inputProps$onFocus.call(inputProps, e);
  };
  var handleValueChange = function handleValueChange(values) {
    setNumber(values.value);
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(values.value, values.formattedValue);
  };
  var handleBlur = function handleBlur(e) {
    var _inputProps$onBlur;
    if (number === '') {
      setAllowEmptyFormatting(false);
    }
    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onBlur = inputProps.onBlur) === null || _inputProps$onBlur === void 0 ? void 0 : _inputProps$onBlur.call(inputProps, e);
  };
  return /*#__PURE__*/React.createElement(CoreInput, _extends({}, props, {
    disabled: disabled,
    "data-t-id": "Input-components"
  }), /*#__PURE__*/React.createElement(PatternFormat, _extends({}, maskSettings, inputProps, {
    allowEmptyFormatting: allowEmptyFormatting,
    className: className,
    disabled: disabled,
    getInputRef: inputRef,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onValueChange: handleValueChange,
    type: type,
    "data-t-id": "Input-components"
  })));
};
export { MaskedInput };